import React, { useState, useEffect } from 'react';
import { size } from 'lodash';
import CreatableSelect from 'react-select/creatable';

export function MultiInputField({
  fieldValues,
  onInputChange,
  isDisabled,
  ...restProps
}) {

  const [inputValue, setInputValue] = useState('');
  const [values, setValues] = useState([]);
  const [vocabValues, setvocabValues] = useState([]);
  
  function convertStringToArray(inputString) {
    const values = inputString.split(',');
    const newArray = values.map(value => {
      const trimmedValue = value.trim();
      return { label: trimmedValue, value: trimmedValue };
    });
    setvocabValues(newArray)
  }

  useEffect (() => {
    if(fieldValues)
    {
      convertStringToArray(fieldValues);
    }
  },[fieldValues])

  useEffect (() => {
    const inputValue = values.map(item => item.value).join(', ');
    if(inputValue)
    {
      onInputChange({name:"vocab",value:inputValue});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[values])

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      if (inputValue.trim() !== '') {
        const newValue = { label: inputValue.trim(), value: inputValue.trim() };
        setValues([...values, newValue]);
        setInputValue('');
      }
    }
  };

  const handleChange = (newValue, actionMeta) => {
    setValues(newValue);
    setvocabValues(newValue);

  };
  return (
    <CreatableSelect
      inputValue={inputValue}
      isClearable
      isMulti
      menuIsOpen={false}
      onChange={handleChange}
      onInputChange={handleInputChange}
      onKeyDown={handleInputKeyPress}
      value={size(values > 0) ?  values : vocabValues}
      isDisabled={isDisabled}
      {...restProps}
    />
  );
}
